(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hg-group-entry"] && !Shopify.designMode) return;
  try {
    
function initHigherGroundGroups(root) {
root.querySelectorAll('[data-hg-groups]').forEach(function(panel) {
if(panel.dataset.ready)return;panel.dataset.ready='true';
panel.querySelector('form').addEventListener('submit',function(event) {
event.preventDefault();
const code=panel.querySelector('input').value.trim().toUpperCase();
const group=Array.from(panel.querySelectorAll('[data-hg-group]')).find(function(item){return item.dataset.code===code;});
const message=panel.querySelector('[data-hg-message]');
if(!group){message.textContent=panel.querySelector('[data-hg-error]').textContent;return;}
if(!group.dataset.url){message.textContent=panel.querySelector('[data-hg-pending]').textContent;return;}
const target=new URL(group.dataset.url,window.location.origin);
if(target.origin===window.location.origin)window.location.assign(target.href);
});
});
}
initHigherGroundGroups(document);
document.addEventListener('shopify:section:load',function(event){initHigherGroundGroups(event.target);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
